const focusableElementsString = [
    'a[href]',
    'area[href]',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'button:not([disabled])',
    'details',
    'summary',
    'iframe',
    'object',
    'embed',
    '[contenteditable]'
].join(',');

/**
 * Inerts elements in the body if the element does not have an ID of dialogs.
 * @param {boolean} shouldInert - Value of inert to set.
 */
const inertElement = (element: Element, shouldInert: boolean): void => {
    element.setAttribute('aria-hidden', shouldInert.toString());

    if (shouldInert) {
        element.setAttribute('inert', '');
    } else {
        element.removeAttribute('inert');
    }

    const elementFocusableChildren = Array.from(element.querySelectorAll(focusableElementsString));

    if (elementFocusableChildren.length) {
        elementFocusableChildren.forEach((focusableElement) => {
            if (shouldInert) {
                focusableElement.setAttribute('tabindex', '-1');
            } else {
                focusableElement.removeAttribute('tabindex');
            }
        });
    }
};

export default inertElement;
